import { ServicesHeroSection } from './components/ServicesHeroSection'
import { ServicesListSection } from './components/ServicesListSection'
import { ConsultationCtaSection } from './components/ConsultationCtaSection'

export function ServicesFeature() {
  return (
    <>
      <ServicesHeroSection />
      <ServicesListSection />
      <ConsultationCtaSection />
    </>
  )
}
